/* eslint-disable @typescript-eslint/no-unused-expressions */
import * as React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import { getUserToken } from "../api/api";
import { Button } from "antd";
// import backimage from "../assets/back.png";
import PageHeader from "../comp/pageheader";
import { makeUUID, storage } from "../util";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  background-size: cover;
  .content {
    margin: 0 auto;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #qrframe {
    width: 300px;
    height: 400px;
  }
  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 13px;
  }
`;

const Login: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const timerRef = React.useRef<any>(0);
  const [astate, setAstate] = React.useState(makeUUID());

  const WxLogin = function (e: any) {
    var r = "default";
    !0 === e.self_redirect
      ? (r = "true")
      : !1 === e.self_redirect && (r = "false");
    var n = document.createElement("iframe") as any,
      i =
        "https://open.weixin.qq.com/connect/qrconnect?appid=" +
        e.appid +
        "&scope=" +
        e.scope +
        "&redirect_uri=" +
        e.redirect_uri +
        "&state=" +
        e.state +
        "&login_type=jssdk&self_redirect=" +
        r +
        "&styletype=" +
        (e.styletype || "") +
        "&sizetype=" +
        (e.sizetype || "") +
        "&bgcolor=" +
        (e.bgcolor || "") +
        "&rst=" +
        (e.rst || "");
    (i += e.style ? "&style=" + e.style : ""),
      (i += e.href ? "&href=" + e.href : ""),
      (i += "en" === e.lang ? "&lang=en" : ""),
      (n.src = i),
      (n.frameBorder = "0"),
      (n.allowTransparency = "true"),
      (n.scrolling = "no"),
      (n.width = "300px"),
      (n.height = "400px");
    var s = document.getElementById(e.id);
    if (s) {
      (s!.innerHTML = ""), s!.appendChild(n);
    }
  };

  React.useEffect(() => {
    const obj = WxLogin({
      self_redirect: true,
      id: "qrframe",
      appid: "wx31222c30b0d497eb",
      scope: "snsapi_login",
      redirect_uri: "https://www.day1leadership.com/webLogin/webLogin.json",
      state: astate,
      style: "black",
      href: "",
    });
  }, []);

  const getAtoken = async () => {
    const ret = await getUserToken(astate);
    if (ret.Tips) {
    } else {
      const { authToken, userId } = ret;
      storage.save("atoken", authToken);
      storage.save("auserid", userId);
      navigate("/group");
    }
  };

  React.useEffect(() => {
    let authToken = storage.get("atoken") || ""; // 可能是{}
    const userId = storage.get("auserid") || "";
    if (authToken && userId) {
      navigate("/group");
      return;
    }

    timerRef.current! = setInterval(() => {
      getAtoken();
    }, 3000);
    return () => {
      clearInterval(timerRef.current!);
      timerRef.current = null;
    };
  }, []);

  return (
    <Container>
      <PageHeader />
      <div className="content">
        <div id="qrframe"></div>
      </div>
      <div className="footer">
        ©2023 领修 Day1leadership.com 版权所有
        <a className="ml10" href="http://beian.miit.gov.cn/">
          浙ICP备2023016684号
        </a>
      </div>
    </Container>
  );
};

export default Login;
